<div class="row">
  <div class="col-12">
    <h4 class="card-title mb-2">Forms</h4>

    <div class="row g-3">
      <div
        *ngFor="let item of availables"
        class="col mini-stats-wid-forms mb-2">
        <a [routerLink]="[forms, item.id]" [routerLinkActive]="['active']">
          <div
            class="card mini-stats-wid mb-2 forms h-100"
            [ngClass]="{ 'bg-secondary bg-opacity-10': item.type === 'MIG' }">
            <div class="card-body px-3 py-2">
              <div class="d-flex h-100 align-content-center align-items-center">
                <div class="flex-grow-1 align-self-center">
                  <h6 class="mb-0 text-secondary">
                    {{ item.name }}
                    {{ item.type === 'MIG' ? ' Snapshot' : '' }} Form
                  </h6>
                </div>
                <div class="flex-shrink-0 align-self-center">
                  <div
                    class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                    <span class="avatar-title">
                      <i class="bx bx-user-check font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
